<div class="widget-container" #IrHeatmapDiv>
  <main>
    <article #fs fullscreen-able [ngClass]="{ 'is-active': isActive, 'fullscreen-padding': isActive}"
      style="background-color: white; overflow: auto;">
      <loading *ngIf="isLoading"> </loading>
      <div>
        <icon-chart [headerConfig]="item.config?.widget_header_config" [pageKey]="pageKey"
          [heading]="item.config['report_heading']" [chartName]="'IRSummery'" [config]="heatMapContainer" [expand]="fs"
          [fullscreen]="isFullscreen" [item]="item" [data]="data"
          (preferenceEmitter)="applyChartPreferences($event)"
          (screenChanges)="fullscreenChanges($event)" (changeDisplays)="changeDisplays($event)" ></icon-chart>
      </div>
      <div [style.display]="noData || waitingForScatterPlot?'none':''" #heatMapContainer>
        <div>
          <app-new-heatmap-chart (gridData)="getgridData($event)" [data]="data"  [props]="props" [config]="config" [item]="item"
            [selectedValue]="selectedValue" [commentsData]="commentsData" [fullscreen]="isFullscreen"></app-new-heatmap-chart>
        </div>
        <div *ngIf="item?.config?.isGridShow&&!import_from_scatter_plot">
          <div class="mb-3 mt-2"><hr></div>
          <div style="display: flex;justify-content: space-between;">
          <div>
            <span style="font-family: Poppins;font-size: 20px;font-weight: 600;line-height: 36px;letter-spacing: 0em;text-align: left; margin-left: 7px;
                  ">{{ gridConfig.pivot? gridConfig.selectedValue+' - All Weeks' :'Summary - '+
              (gridConfig.selectedValue | date: 'dd MMM yyyy') }}</span>
            
          </div>
          <mat-icon matTooltip="Export List"  class="exportic" svgIcon="dotmenu_circle" [matMenuTriggerFor]="menu"></mat-icon>
        </div>
        <pivot-grid #PivotGrid *ngIf="isDataLoaded" [dateFormat]="dateFormat" [data]="gridData" [item]="item"
              [columnDef]="columnDefs" pagination="false" [pivot]="pivot" ></pivot-grid>
        </div>
      </div>
      <div style="height: auto; width: auto; " *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>
      <div style="height: 300px; width: auto;" *ngIf="waitingForScatterPlot">
        <span class="bg-text" style="top: 50%">Select dots in the scatter plot and click the 
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_31331_5324)">
              <rect x="0" y="0" width="28" height="28" rx="14" fill="#1363DF"/>
            </g>
            <rect x="6.5" y="6.5" width="6" height="6" rx="1.5" fill="white"/>
            <rect x="6.5" y="15.5" width="6" height="6" rx="1.5" fill="white"/>
            <rect x="15.5" y="6.5" width="6" height="6" rx="1.5" fill="white"/>
            <rect x="15.5" y="15.5" width="6" height="6" rx="1.5" fill="white"/>
          </svg>
        icon to see more data here</span>
      </div>
      <mat-menu #menu="matMenu" >
        <button mat-menu-item  (click)="exportXls()"><mat-icon svgIcon="xls" ></mat-icon>Export to Excel</button>
      </mat-menu>

    </article>
  </main>
</div>